import React from 'react'
import PropTypes from 'prop-types'
import WrappedModal from '@/components/WrappedModal'

import Img from './Img'

class Modal extends React.Component {
  state = {
    baseComponent: ''
  }

  static propTypes = {
    baseProps: PropTypes.object,
    title: PropTypes.string,
    width: PropTypes.number
  }

  render () {
    const { children, baseProps } = this.props
    const baseComponent = <Img />
    const defaultClassName = 'i2-img'
    return (
      <WrappedModal
        className={defaultClassName}
        children={children}
        baseProps={{ ...baseProps }}
        baseComponent={baseComponent}
        title={null}
        footer={null}
        width={900}
        styles={{
          body: {
            maxHeight: '80vh',
            overflow: 'auto',
            boxSizing: 'border-box'
          }
        }}
      />
    )
  }
}

export default Modal
